import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { CatalogLauncherWizardComponent, CatalogService } from '@serengeti/serengeti-app';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-market-product-create',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class MarketProductDetailComponent implements OnInit, OnDestroy {

  id: string;
  product: any;
  catalog: any;
	selectedTenant: any;

  routeSubscription: Subscription;
	@ViewChild('wizard', {static: false}) wizard: CatalogLauncherWizardComponent;

  constructor(
		private router: Router,
		private route: ActivatedRoute,
		private catalogService: CatalogService
  ) {
		this.routeSubscription = this.router.events.pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
		.subscribe(() => {
      this.id = this.route.snapshot.paramMap.get('id');
		});
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  onConfigCatalog($event: any) {
    this.product = $event;
    if (this.product.catalog) {
      this.catalog = JSON.parse(JSON.stringify(this.product.catalog.catalog));
      this.catalog.activeVersion = this.product.catalog;  
    } else {
      this.catalog = null;
    }
  }

  onCatalogConfigured($event: any) {
    this.product.catalogConfiguration = JSON.stringify($event);
  }

	onTenantSelected(selectedTenant: any) {
		this.selectedTenant = selectedTenant;
	}
  
	getSoftwareTemplateApps(softwareTemplates: any[], resourceTemplate: any): any[] {
		return this.catalogService.getSoftwareTemplateApps(softwareTemplates, resourceTemplate);
	}

	getSoftwareTemplate(softwareTemplates: any[], resourceTemplate: any) {
		return this.catalogService.getSoftwareTemplate(softwareTemplates, resourceTemplate);
	}

	onSoftwareConfigure($event: any) {
		this.wizard.onSoftwareConfigure($event);
	}

}
